import ApplicationTable from './ApplicationTable';
import TabbedList from './ApplicationGrid';
import LimitDropdown from '../../common/LimitDropdown';

export function LeadApplicationsView({
  isLoading,
  leads,
  isGridView,
  onApplicationClick,
}) {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex items-center justify-center min-h-[400px]">
        <div className="w-8 h-8 border-4 border-blue-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const rows = Array.isArray(leads) ? leads : [];

  return isGridView ? (
    <TabbedList filteredApplications={rows} onApplicationClick={onApplicationClick} />
  ) : (
    <ApplicationTable filteredApplications={rows} onApplicationClick={onApplicationClick} />
  );
}

export function LeadPagination({
  totalPages,
  currentPage,
  onPageChange,
  isLoading,
  limit,
  onLimitChange,
}) {
  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      {totalPages > 1 && (
        <>
          <button
            onClick={() => onPageChange(Math.max((currentPage || 1) - 1, 1))}
            disabled={(currentPage || 1) === 1 || isLoading}
            className={`px-2 md:px-3 py-2 rounded-md ${
              (currentPage || 1) === 1 || isLoading
                ? 'bg-gray-200/50 text-gray-400 cursor-default'
                : 'bg-gray-100 text-[#005787] hover:bg-gray-300'
            }`}
          >
            &lt;
          </button>

          {Array.from({ length: totalPages }).map((_, index) => {
            const pageNumber = index + 1;
            const current = currentPage || 1;
            if (
              pageNumber === 1 ||
              pageNumber === totalPages ||
              (pageNumber >= current - 1 && pageNumber <= current + 1)
            ) {
              return (
                <button
                  key={pageNumber}
                  onClick={() => onPageChange(pageNumber)}
                  className={`px-3 md:px-4 py-1.5 md:py-2 rounded-md border ${
                    current === pageNumber
                      ? 'bg-[#005787] text-white border-[#334155]'
                      : 'bg-gray-100 text-[#005787] hover:bg-gray-300 border-gray-200'
                  }`}
                >
                  {pageNumber}
                </button>
              );
            }
            if (pageNumber === current - 2 || pageNumber === current + 2) {
              return (
                <span key={pageNumber} className="px-2 py-1 text-gray-500">
                  ...
                </span>
              );
            }
            return null;
          })}

          <button
            onClick={() => onPageChange(Math.min((currentPage || 1) + 1, totalPages || 1))}
            disabled={(currentPage || 1) === (totalPages || 1) || isLoading}
            className={`px-2 md:px-3 py-2 rounded-md ${
              (currentPage || 1) === (totalPages || 1) || isLoading
                ? 'bg-gray-200/50 text-gray-400 cursor-default'
                : 'bg-gray-100 text-[#005787] hover:bg-gray-300'
            }`}
          >
            &gt;
          </button>
        </>
      )}
      <div className="hidden md:flex items-center gap-3 ml-4">
        <LimitDropdown value={limit} onChange={onLimitChange} />
      </div>
    </div>
  );
}